// Whitelisted internalAgentIds the backend accepts on /agents/tenants/:tenantId/:internalAgentId/*.
// The backend split the intake-call agent into outbound + inbound variants
// (the bare "intake-call-agent" id is no longer accepted).
export const AGENT_INTERNAL_IDS = Object.freeze({
  OUTBOUND_INTAKE_CALL: "outbound-intake-call-agent",
  INBOUND_INTAKE_CALL: "inbound-intake-call-agent",
  // "Bari" is the FE/marketing name; campaign voice config + preview target the
  // outbound intake-call agent.
  BARI: "outbound-intake-call-agent",
});

// Used when the user clicks a card's ▶ button without first typing a greeting.
// Personalized with the voice's agent name so each persona introduces itself,
// and ends with a hint that the user can hear their own greeting by typing one.
// Backend's Mustache renderer has no `agentName` template var, so we substitute
// client-side before sending.
export const buildDefaultPreviewMessage = (agentName) => {
  const name = (agentName || "your assistant").trim() || "your assistant";
  return `Hi, this is ${name}. Modify the greeting to hear your actual message.`;
};
